<script>
  export default {
    name: 'relatorio-loading',
    data () {
      return {}
    },
    computed: {},
    mounted () {},
    destroyed () {},
    methods: {},
    components: {}
  }
</script>

<template>
  <div class="loader">
    <div class="text-center"><i class="fa fa-spin fa-spinner"></i></div>
    Gerando o relatório
  </div>
</template>



// WEBPACK FOOTER //
// _RelatorioLoading.vue?58e86633